import Link from 'next/link';
// import './Nav.scss'; // Removed for version update
import { useEffect, useState } from 'react';
import store from '../../../store';
import { useSelector } from 'react-redux';

const nav = ({ permissions }) => {
  const [currentTab, setcurrentTab] = useState();
  const [refundImg, setRefundImg] = useState(true);
  const [settlementsActive, setsettlementsActive] = useState(false);
  const userRoleName = useSelector((state) => state.user.roleName);
  useEffect(() => {
    let currentRoute = window.location.href.split('/')[3];
    switch (currentRoute) {
      case '':
        setcurrentTab(1);
        break;
      case 'orders':
        setcurrentTab(3);
        break;
      case 'settlements':
        setcurrentTab(27);
        break;
      case 'refund':
        setcurrentTab(5);
        break;
      case 'transactions':
        setcurrentTab(7);
        break;
      case 'customers':
        setcurrentTab(9);
        break;
      case 'merchants':
        setcurrentTab(11);
        break;
      case 'abandoned-cart':
        setcurrentTab(13);
        break;
      case 'settings':
        setcurrentTab(15);
        break;
      case 'users':
        setcurrentTab(17);
        break;
      case 'roles':
        setcurrentTab(19);
        break;
      case 'permissions':
        setcurrentTab(21);
        break;
      case 'historical-data':
        setcurrentTab(23);
        break;
      case 'address-annotation':
        setcurrentTab(30);
        break;
      case 'merchant-onboarding':
        setcurrentTab(25);
        break;
      case 'schedule_notifications':
        setcurrentTab(29);
        break;
      case 'reports':
        setcurrentTab(31);
        break;
      case 'billing':
        setcurrentTab(33);
        break;
    }
  });
  if (['External CRM'].includes(userRoleName)) return null;
  return (
    permissions && (
      <div className='sidebar'>
        <ul>
          <img src='/images/logo-business-suit.svg' className='business-logo' />
          {/* <li onClick={() => setcurrentTab(1)} className={currentTab == 1 ? 'active' : ''} id='nav-item-dashboard'>
            <Link href='/'>
              <a className='fill fs14 lh-50 display-b'>
                <svg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M7.7 8.31H3.3C1.48 8.31 0 6.83 0 5.01V3.29C0 1.48 1.48 0 3.3 0H7.7C9.52 0 11 1.48 11 3.29V5.01C11 6.83 9.52 8.31 7.7 8.31ZM3.3 2C2.58 2 2 2.58 2 3.29V5.01C2 5.72 2.58 6.31 3.3 6.31H7.7C8.41 6.31 9 5.73 9 5.01V3.29C9 2.58 8.42 2 7.7 2H3.3Z'
                    fill='#9BABC5'
                  />
                  <path
                    d='M7.7 24.0001H3.3C1.48 24.0001 0 22.5201 0 20.7001V13.6001C0 11.7801 1.48 10.3101 3.3 10.3101H7.7C9.52 10.3101 11 11.7901 11 13.6001V20.7001C11 22.5201 9.52 24.0001 7.7 24.0001ZM3.3 12.3101C2.59 12.3101 2 12.8901 2 13.6001V20.7001C2 21.4201 2.58 22.0001 3.3 22.0001H7.7C8.42 22.0001 9 21.4201 9 20.7001V13.6001C9 12.8901 8.42 12.3101 7.7 12.3101H3.3Z'
                    fill='#9BABC5'
                  />
                  <path
                    d='M20.7 23.9999H16.3C14.48 23.9999 13 22.5199 13 20.6999V18.9799C13 17.1599 14.48 15.6899 16.3 15.6899H20.71C22.53 15.6899 24.01 17.1699 24.01 18.9799V20.6999C24 22.5199 22.52 23.9999 20.7 23.9999ZM16.3 17.6899C15.59 17.6899 15 18.2699 15 18.9799V20.6999C15 21.4099 15.58 21.9999 16.3 21.9999H20.71C21.42 21.9999 22.01 21.4199 22.01 20.6999V18.9799C22.01 18.2699 21.43 17.6899 20.71 17.6899H16.3Z'
                    fill='#9BABC5'
                  />
                  <path
                    d='M20.7 13.69H16.3C14.48 13.69 13 12.21 13 10.39V3.29C13 1.48 14.48 0 16.3 0H20.71C22.52 0 24 1.48 24 3.29V10.39C24 12.21 22.52 13.69 20.7 13.69ZM16.3 2C15.58 2 15 2.58 15 3.29V10.39C15 11.1 15.58 11.69 16.3 11.69H20.71C21.42 11.69 22.01 11.11 22.01 10.39V3.29C22 2.58 21.42 2 20.7 2H16.3Z'
                    fill='#9BABC5'
                  />
                </svg>{' '}
                <span className='some'>Dashboard</span>
              </a>
            </Link>
          </li> */}
          {/* <li onClick={()=>setcurrentTab(2)} className={currentTab==2?"active":""}><Link href="/"><a className="fill fs14 lh-50 display-b"><svg width="26" height="14" viewBox="0 0 26 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.04 5.85L16.89 1" stroke="#9BABC5" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/><path d="M1 8.04004L5.43 12.46L6.06 11.83" stroke="#9BABC5" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/><path d="M8.16016 8.26998L12.5802 12.69L24.0502 1.22998" stroke="#9BABC5" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/></svg> Settlements</a></Link></li> */}
          {/* {permissions.indexOf('view_order') !== -1 && (
            <li onClick={() => setcurrentTab(3)} className={currentTab == 3 ? 'active' : ''} id='nav-item-order'>
              <Link href='/orders'>
                <a className='fill fs14 lh-50 display-b'>
                  <svg width='25' height='24' viewBox='0 0 21 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M15.7962 4.46973H4.79623C3.22623 4.46973 1.91623 5.68973 1.81623 7.25973L1.00623 19.8197C0.896232 21.5397 2.25623 22.9997 3.98623 22.9997H16.6162C18.3462 22.9997 19.7062 21.5397 19.5962 19.8197L18.7862 7.26973C18.6762 5.69973 17.3762 4.46973 15.7962 4.46973Z'
                      stroke='#9BABC5'
                      strokeWidth='2'
                      strokeMiterlimit='10'
                    />
                    <path
                      d='M6.82617 4.47C6.82617 2.56 8.37617 1 10.2962 1C12.2162 1 13.7662 2.56 13.7662 4.47'
                      stroke='#9BABC5'
                      strokeWidth='2'
                      strokeMiterlimit='10'
                    />
                  </svg>
                  <span>Orders</span>
                </a>
              </Link>
            </li>
          )} */}
          {/* {permissions.includes('view_reports') && (
            <li onClick={() => setcurrentTab(31)} className={currentTab == 31 ? 'active' : ''} id='nav-item-report'>
              <Link href='/reports'>
                <a className='stroke fs14 lh-50 display-b'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='26' height='26' viewBox='0 0 26 26' fill='none'>
                    <path
                      d='M13.0001 22.5335H5.20011C6.63878 22.5335 7.80011 21.3721 7.80011 19.9335V6.0668C7.80011 4.62813 8.96145 3.4668 10.4001 3.4668H18.0094C19.4481 3.4668 20.6094 4.62813 20.6094 6.0668V21.4935'
                      stroke='#9BABC5'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <path
                      d='M12.1336 17.3335H13.6762'
                      stroke='#9BABC5'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <path
                      d='M12.1336 8.66699H16.2763'
                      stroke='#9BABC5'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <path
                      d='M12.1336 13H16.2763'
                      stroke='#9BABC5'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <path
                      d='M5.19969 22.5333C3.76102 22.5333 2.59969 21.372 2.59969 19.9333V15.6C2.59969 14.1613 3.76102 13 5.19969 13H7.79969'
                      stroke='#9BABC5'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <path
                      d='M17.8097 19.7515L20.6091 22.5508L23.3997 19.7515'
                      stroke='#9BABC5'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                  </svg>
                  <span>Reports</span>
                </a>
              </Link>
            </li>
          )} */}

          {/* {permissions.includes('view_refund') && (
            <li
              onClick={() => setcurrentTab(5)}
              className={`${currentTab == 5 ? 'active' : ''}`}
              onMouseEnter={() => setRefundImg(false)}
              onMouseLeave={() => setRefundImg(true)}
              id='nav-item-refund'
            >
              <Link href='/refund'>
                <a className='fs14 lh-50 display-b'>
                  {!refundImg || currentTab === 5 ? (
                    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='28' viewBox='0 0 24 28' fill='none'>
                      <path
                        d='M13.3 7.6L10 4.3L13.3 1'
                        stroke='url(#paint0_linear_1_17454)'
                        strokeWidth='2'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M12 4.2998C18.1 4.2998 23 9.1998 23 15.2998C23 21.3998 18.1 26.2998 12 26.2998C5.9 26.2998 1 21.3998 1 15.2998'
                        stroke='url(#paint1_linear_1_17454)'
                        strokeWidth='2'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M1 15.3008C0.999999 9.20078 5.9 4.30078 12 4.30078'
                        stroke='url(#paint2_linear_1_17454)'
                        strokeWidth='2'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeDasharray='1 4'
                      />
                      <path
                        d='M12 9.2998C8.7 9.2998 6 11.9998 6 15.2998C6 18.5998 8.7 21.2998 12 21.2998C15.3 21.2998 18 18.5998 18 15.2998C18 11.9998 15.3 9.2998 12 9.2998ZM13 13.7998H13.9C14.1 13.7998 14.3 13.9998 14.3 14.1998C14.3 14.3998 14.1 14.5998 13.9 14.5998H13C12.8 15.4998 12.2 16.0998 11.4 16.0998H11L12.9 18.3998C13 18.5998 13 18.7998 12.8 18.9998C12.7 19.0998 12.6 19.0998 12.6 19.0998C12.5 19.0998 12.4 18.9998 12.3 18.8998L9.9 15.8998C9.8 15.7998 9.8 15.5998 9.9 15.4998C10 15.3998 10.1 15.2998 10.3 15.2998H11.5C11.8 15.2998 12.1 14.9998 12.2 14.5998H10.3C10.1 14.5998 9.9 14.3998 9.9 14.1998C9.9 13.9998 10.1 13.7998 10.3 13.7998H12.2C12.1 13.3998 11.8 13.0998 11.5 13.0998H10.3C10.1 13.0998 9.9 12.8998 9.9 12.6998C9.9 12.4998 10 12.2998 10.2 12.2998H13.8C14 12.2998 14.2 12.4998 14.2 12.6998C14.2 12.8998 14 13.0998 13.8 13.0998H12.7C12.8 13.2998 12.9 13.4998 13 13.7998Z'
                        fill='url(#paint3_linear_1_17454)'
                      />
                      <defs>
                        <linearGradient
                          id='paint0_linear_1_17454'
                          x1='10'
                          y1='1'
                          x2='15.28'
                          y2='3.64'
                          gradientUnits='userSpaceOnUse'
                        >
                          <stop stopColor='#000428' />
                          <stop offset='1' stopColor='#004B8D' />
                        </linearGradient>
                        <linearGradient
                          id='paint1_linear_1_17454'
                          x1='1'
                          y1='4.2998'
                          x2='23'
                          y2='26.2998'
                          gradientUnits='userSpaceOnUse'
                        >
                          <stop stopColor='#000428' />
                          <stop offset='1' stopColor='#004B8D' />
                        </linearGradient>
                        <linearGradient
                          id='paint2_linear_1_17454'
                          x1='12'
                          y1='15.3008'
                          x2='0.999999'
                          y2='4.30078'
                          gradientUnits='userSpaceOnUse'
                        >
                          <stop stopColor='#000428' />
                          <stop offset='1' stopColor='#004B8D' />
                        </linearGradient>
                        <linearGradient
                          id='paint3_linear_1_17454'
                          x1='18'
                          y1='21.2998'
                          x2='6'
                          y2='9.29981'
                          gradientUnits='userSpaceOnUse'
                        >
                          <stop stopColor='#EDCE4D' />
                          <stop offset='1' stopColor='#F09819' />
                        </linearGradient>
                      </defs>
                    </svg>
                  ) : (
                    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='28' viewBox='0 0 24 28' fill='none'>
                      <path
                        d='M13.3 7.6L10 4.3L13.3 1'
                        stroke='#9BABC5'
                        strokeWidth='2'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M12 4.2998C18.1 4.2998 23 9.1998 23 15.2998C23 21.3998 18.1 26.2998 12 26.2998C5.9 26.2998 1 21.3998 1 15.2998'
                        stroke='#9BABC5'
                        strokeWidth='2'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M1 15.3008C0.999999 9.20078 5.9 4.30078 12 4.30078'
                        stroke='#9BABC5'
                        strokeWidth='2'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeDasharray='1 4'
                      />
                      <path
                        d='M12 9.2998C8.7 9.2998 6 11.9998 6 15.2998C6 18.5998 8.7 21.2998 12 21.2998C15.3 21.2998 18 18.5998 18 15.2998C18 11.9998 15.3 9.2998 12 9.2998ZM13 13.7998H13.9C14.1 13.7998 14.3 13.9998 14.3 14.1998C14.3 14.3998 14.1 14.5998 13.9 14.5998H13C12.8 15.4998 12.2 16.0998 11.4 16.0998H11L12.9 18.3998C13 18.5998 13 18.7998 12.8 18.9998C12.7 19.0998 12.6 19.0998 12.6 19.0998C12.5 19.0998 12.4 18.9998 12.3 18.8998L9.9 15.8998C9.8 15.7998 9.8 15.5998 9.9 15.4998C10 15.3998 10.1 15.2998 10.3 15.2998H11.5C11.8 15.2998 12.1 14.9998 12.2 14.5998H10.3C10.1 14.5998 9.9 14.3998 9.9 14.1998C9.9 13.9998 10.1 13.7998 10.3 13.7998H12.2C12.1 13.3998 11.8 13.0998 11.5 13.0998H10.3C10.1 13.0998 9.9 12.8998 9.9 12.6998C9.9 12.4998 10 12.2998 10.2 12.2998H13.8C14 12.2998 14.2 12.4998 14.2 12.6998C14.2 12.8998 14 13.0998 13.8 13.0998H12.7C12.8 13.2998 12.9 13.4998 13 13.7998Z'
                        fill='#9BABC5'
                      />
                    </svg>
                  )}
                  <span className='some'>Refund</span>
                </a>
              </Link>
            </li>
          )} */}
          {/* {permissions.includes('view_settlements') && (
            <li
              onClick={() => setcurrentTab(27)}
              className={`${currentTab == 27 ? 'active' : ''}`}
              onMouseEnter={() => setsettlementsActive(true)}
              onMouseLeave={() => setsettlementsActive(false)}
              id='nav-item-settlement'
            >
              <Link href='/settlements'>
                <a className='fs14 lh-50 display-b'>
                  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <rect width='32' height='32' fill='none' />
                    <path
                      d='M15.0391 14.85L19.8891 10'
                      stroke={settlementsActive || currentTab == 27 ? '#004B8D' : '#9BABC5'}
                      stroke-width='2'
                      stroke-miterlimit='10'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <path
                      d='M4 17.0391L8.43 21.4591L9.06 20.8291'
                      stroke={settlementsActive || currentTab == 27 ? '#004B8D' : '#9BABC5'}
                      stroke-width='2'
                      stroke-miterlimit='10'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <path
                      d='M11.1602 17.2705L15.5802 21.6905L27.0502 10.2305'
                      stroke={settlementsActive || currentTab == 27 ? '#004B8D' : '#9BABC5'}
                      stroke-width='2'
                      stroke-miterlimit='10'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                  </svg>
                  <span className='some'>Settlements</span>
                </a>
              </Link>
            </li>
          )} */}
          {/* <li onClick={()=>setcurrentTab(4)} className={currentTab==4?"active":""}><Link href="/"><a className="fill fs14 lh-50 display-b"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 17H11C10.45 17 10 16.55 10 16C10 15.45 10.45 15 11 15H19C19.55 15 20 15.45 20 16C20 16.55 19.55 17 19 17Z" fill="#9BABC5"/><path d="M19 9H11C10.45 9 10 8.55 10 8C10 7.45 10.45 7 11 7H19C19.55 7 20 7.45 20 8C20 8.55 19.55 9 19 9Z" fill="#9BABC5"/><path d="M20 0H10C7.79 0 6 1.79 6 4V11H4C1.79 11 0 12.79 0 15V20C0 22.21 1.79 24 4 24H20C22.21 24 24 22.21 24 20V4C24 1.79 22.21 0 20 0ZM4 22C2.9 22 2 21.1 2 20V15C2 13.9 2.9 13 4 13H6V20C6 21.1 5.1 22 4 22ZM22 20C22 21.1 21.1 22 20 22H7.46C7.8 21.41 8 20.73 8 20V4C8 2.9 8.9 2 10 2H20C21.1 2 22 2.9 22 4V20Z" fill="#9BABC5"/></svg> Reports</a></Link></li> */}
          {/* <li onClick={()=>setcurrentTab(5)} className={currentTab==5?"active":""}><Link href="/"><a className="fill fs14 lh-50 display-b"><svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.56 10.7197L4.28 13.9997L1 10.7197" stroke="#9BABC5" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/><path d="M4.28027 12C4.28027 5.92 9.20027 1 15.2803 1C21.3603 1 26.2803 5.92 26.2803 12C26.2803 18.08 21.3603 23 15.2803 23C12.2403 23 9.49027 21.77 7.50027 19.78" stroke="#9BABC5" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/><path d="M16.7874 19.0701L10.7476 13.0302H13.7627C15.4345 13.0302 16.7778 11.6773 16.7778 10.0151C16.7778 8.34327 15.4248 7 13.7627 7H10.7476H19.8025" stroke="#9BABC5" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/><path d="M10.7476 10.0151H19.8122" stroke="#9BABC5" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/></svg> Initiate Refund</a></Link></li> */}
          {/* <li onClick={()=>setcurrentTab(6)} className={currentTab==6?"active":""}><Link href="/"><a className="fill fs14 lh-50 display-b"><svg width="21" height="23" viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5.51 4.61L10.03 1L14.55 4.61L19.07 1V19.07C19.07 20.69 17.76 22 16.14 22H3.93C2.31 22 1 20.69 1 19.07V1Z" stroke="#9BABC5" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/><path d="M6.03027 16.3101H14.0303" stroke="#9BABC5" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/><path d="M6.03027 10.3101H14.0303" stroke="#9BABC5" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/></svg> Invoices</a></Link></li> */}

          {/* {permissions.includes('view_billing') && (
            <li
              onClick={() => setcurrentTab(33)}
              className={`${currentTab == 33 ? 'active' : ''}`}
              id='nav-item-billing'
            >
              <Link href='/billing'>
                <a className='fs14 lh-50 display-b fill'>
                  <svg width='32' height='32' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'>
                    <path
                      style={{
                        lineHeight: 'normal',
                        textIndent: 0,
                        textAlign: 'start',
                        textDecorationLine: 'none',
                        textDecorationStyle: 'solid',
                        textDecorationColor: '#9BABC5',
                        textTransform: 'none',
                        blockProgression: 'tb',
                        isolation: 'auto',
                        mixBlendMode: 'normal',
                      }}
                      fill='#9BABC5'
                      d='M 4.5 2 C 3.6774686 2 3 2.6774686 3 3.5 L 3 12.5 C 3 13.322531 3.6774686 14 4.5 14 L 11.5 14 C 12.322531 14 13 13.322531 13 12.5 L 13 3.5 C 13 2.6774686 12.322531 2 11.5 2 L 4.5 2 z M 4.5 3 L 11.5 3 C 11.781469 3 12 3.2185314 12 3.5 L 12 12.5 C 12 12.781469 11.781469 13 11.5 13 L 4.5 13 C 4.2185314 13 4 12.781469 4 12.5 L 4 3.5 C 4 3.2185314 4.2185314 3 4.5 3 z M 5 5 L 5 6 L 11 6 L 11 5 L 5 5 z M 5 8 L 5 9 L 9 9 L 9 8 L 5 8 z M 10 8 L 10 9 L 11 9 L 11 8 L 10 8 z M 5 10 L 5 11 L 9 11 L 9 10 L 5 10 z M 10 10 L 10 11 L 11 11 L 11 10 L 10 10 z'
                    />
                  </svg>
                  <span className='some'>Billing</span>
                </a>
              </Link>
            </li>
          )} */}
          {/* {(permissions.includes('view_transactions') || permissions.includes('view_dangled_transactions')) && (
            <li onClick={() => setcurrentTab(7)} className={currentTab == 7 ? 'active' : ''} id='nav-item-transaction'>
              <Link href='/transactions'>
                <a className='fill fs14 lh-50 display-b'>
                  <svg width='25' height='24' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512.001 512.001'>
                    <path
                      d='M443.077,379.077c-14.594,0-28.244-7.18-36.511-19.206l-21.682-31.538c-25.541,45.795-74.094,75.36-128.883,75.36
			c-76.452,0-139.524-58.396-146.96-132.923h14.037c5.484,0,10.518-3.039,13.071-7.894c2.553-4.854,2.206-10.724-0.901-15.243
			l-21.53-31.316l-32.624-47.454c-2.754-4.007-7.306-6.402-12.17-6.402c-0.608,0-1.211,0.037-1.807,0.11
			c-0.596,0.073-1.183,0.183-1.76,0.326c-1.442,0.359-2.818,0.932-4.081,1.697c-1.768,1.07-3.318,2.515-4.523,4.268L2.599,247.632
			c-3.107,4.519-3.454,10.39-0.901,15.243c2.553,4.853,7.587,7.895,13.072,7.895h15.24c3.514,54.931,26.587,106.091,65.859,145.364
			c42.773,42.773,99.642,66.329,160.132,66.329s117.359-23.556,160.132-66.329c11.371-11.371,21.44-23.845,30.085-37.178
			C445.176,379.029,444.13,379.077,443.077,379.077z'
                      fill='#9BABC5'
                    />

                    <path
                      d='M267.255,241.231h-22.505c-4.266,0-7.736-3.47-7.736-7.736v-11.253c0-4.265,3.47-7.735,7.736-7.735h22.505
			c4.266,0,7.736,3.47,7.736,7.735c0,8.157,6.613,14.769,14.769,14.769c8.156,0,14.769-6.613,14.769-14.769
			c0-19.366-14.848-35.325-33.759-37.103v-7.907c0-8.157-6.613-14.769-14.769-14.769c-8.157,0-14.769,6.613-14.769,14.769v7.907
			c-18.91,1.778-33.759,17.737-33.759,37.103v11.253c0,20.554,16.721,37.275,37.275,37.275h22.505c4.266,0,7.736,3.47,7.736,7.736
			v11.253c0,4.265-3.471,7.736-7.736,7.736h-22.505c-4.266,0-7.736-3.47-7.736-7.735c0-8.157-6.613-14.769-14.769-14.769
			c-8.156,0-14.769,6.613-14.769,14.769c0,19.366,14.848,35.325,33.759,37.103v7.906c0,8.157,6.613,14.769,14.769,14.769
			c8.157,0,14.769-6.613,14.769-14.769v-7.907c18.909-1.778,33.759-17.737,33.759-37.103v-11.253
			C304.529,257.952,287.809,241.231,267.255,241.231z'
                      fill='#9BABC5'
                    />

                    <path
                      d='M510.303,249.125c-2.554-4.854-7.587-7.894-13.072-7.894h-15.24c-3.514-54.931-26.587-106.091-65.859-145.364
			C373.36,53.095,316.49,29.539,256.001,29.539S138.641,53.095,95.869,95.868c-11.371,11.371-21.44,23.845-30.085,37.178
			c1.041-0.074,2.087-0.122,3.14-0.122c14.595,0,28.244,7.18,36.511,19.206l21.682,31.538
			c25.541-45.795,74.094-75.359,128.883-75.359c76.452,0,139.524,58.396,146.96,132.923h-14.037c-5.484,0-10.518,3.039-13.071,7.894
			c-2.553,4.854-2.206,10.724,0.901,15.243l21.53,31.316l32.624,47.454c0.689,1.002,1.49,1.903,2.38,2.691
			c2.67,2.364,6.143,3.711,9.791,3.711c4.863,0,9.416-2.395,12.171-6.402l19.554-28.443l34.599-50.326
			C512.51,259.848,512.856,253.978,510.303,249.125z'
                      fill='#9BABC5'
                    />
                  </svg>
                  <span>Transactions</span>
                </a>
              </Link>
            </li>
          )} */}

          {/* {permissions.indexOf('view_customers') !== -1 && (
            <li onClick={() => setcurrentTab(9)} className={currentTab == 9 ? 'active' : ''} id='nav-item-customer'>
              <Link href='/customers/customer'>
                <a className='fill fs14 lh-50 display-b'>
                  <svg width='25' height='24' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512.001 512.001'>
                    <circle cx='256' cy='119.631' r='87' fill='#9BABC5' />
                    <circle cx='432' cy='151.63' r='55' fill='#9BABC5' />
                    <circle cx='80' cy='151.63' r='55' fill='#9BABC5' />
                    <path
                      d='m134.19 256.021c-21.65-17.738-41.257-15.39-66.29-15.39-37.44 0-67.9 30.28-67.9 67.49v109.21c0 16.16 13.19 29.3 29.41 29.3 70.026 0 61.59 1.267 61.59-3.02 0-77.386-9.166-134.137 43.19-187.59z'
                      fill='#9BABC5'
                    />
                    <path
                      d='m279.81 241.03c-43.724-3.647-81.729.042-114.51 27.1-54.857 43.94-44.3 103.103-44.3 175.48 0 19.149 15.58 35.02 35.02 35.02 211.082 0 219.483 6.809 232-20.91 4.105-9.374 2.98-6.395 2.98-96.07 0-71.226-61.673-120.62-111.19-120.62z'
                      fill='#9BABC5'
                    />
                    <path
                      d='m444.1 240.63c-25.17 0-44.669-2.324-66.29 15.39 51.965 53.056 43.19 105.935 43.19 187.59 0 4.314-7.003 3.02 60.54 3.02 16.8 0 30.46-13.61 30.46-30.34v-108.17c0-37.21-30.46-67.49-67.9-67.49z'
                      fill='#9BABC5'
                    />
                  </svg>{' '}
                  <span>Customers</span>
                </a>
              </Link>
            </li>
          )} */}

          {permissions.indexOf('view_merchant') !== -1 && (
            <li onClick={() => setcurrentTab(11)} className={currentTab == 11 ? 'active' : ''} id='nav-item-merchant'>
              <Link href='/merchants/merchant'>
                <a className='partial-fill fs14 lh-50 display-b'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                    <path
                      d='M12.5194 22.849H5.0791C4.06906 22.849 3.24902 22.0233 3.24902 21.0064V11.0686'
                      stroke='#9BABC5'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <path
                      d='M20.7402 10.9378V12.3373'
                      stroke='#9BABC5'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                    <path
                      d='M1.1388 6.62838C0.51877 8.79313 2.04884 11.0989 4.27894 11.119C4.29894 11.119 4.30894 11.119 4.32894 11.119C5.97901 11.119 7.39908 10.2027 8.15911 8.86362C8.91914 10.2027 10.3492 11.119 11.9893 11.119C13.6294 11.119 15.0594 10.2027 15.8195 8.86362C16.5795 10.2027 18.0095 11.119 19.6496 11.119C19.6696 11.119 19.6796 11.119 19.6996 11.119C21.9397 11.0989 23.4598 8.79313 22.8398 6.62838L21.7197 3.75881C21.2497 2.12769 19.7496 1 18.0495 1H5.92901C4.22893 1 2.72887 2.12769 2.25885 3.75881L1.1388 6.62838Z'
                      stroke='#9BABC5'
                      stroke-width='2'
                      stroke-linecap='round'
                      className='path-to-fill'
                      stroke-linejoin='round'
                    />
                    <path
                      d='M18.9992 15.3378L20.2193 17.8851L22.9994 18.2677L20.9693 20.221L21.4693 23L18.9992 21.6609L16.5291 23L17.0291 20.221L14.999 18.2677L17.7791 17.8851L18.9992 15.3378Z'
                      stroke='#9BABC5'
                      stroke-width='2'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                    />
                  </svg>
                  <span>Merchants</span>
                </a>
              </Link>
            </li>
          )}

          {/* {permissions.indexOf('abandoned_cart') != -1 && (
            <li onClick={() => setcurrentTab(13)} className={currentTab == 13 ? 'active' : ''} id='nav-item-abc'>
              <Link href='/abandoned-cart'>
                <a className='fill fs14 lh-50 display-b'>
                  <svg width='20' height='22' viewBox='0 0 20 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      fill='#9BABC5'
                      d='M10 19.5c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5zm3.5-1.5c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5zm1.336-5l1.977-7h-16.813l2.938 7h11.898zm4.969-10l-3.432 12h-12.597l.839 2h13.239l3.474-12h1.929l.743-2h-4.195z'
                    />
                  </svg>{' '}
                  <span className='some'>Abandoned Cart</span>
                </a>
              </Link>
            </li>
          )} */}
          {permissions.indexOf('setting') != -1 && (
            <li onClick={() => setcurrentTab(15)} className={currentTab == 15 ? 'active' : ''} id='nav-item-setting'>
              <Link href='/settings'>
                <a className='fill fs14 lh-50 display-b'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='20'
                    height='22'
                    viewBox='0 0 122.88 122.878'
                    fill='none'
                  >
                    <g>
                      <path
                        fill='#9BABC5'
                        d='M101.589,14.7l8.818,8.819c2.321,2.321,2.321,6.118,0,8.439l-7.101,7.101 c1.959,3.658,3.454,7.601,4.405,11.752h9.199c3.283,0,5.969,2.686,5.969,5.968V69.25c0,3.283-2.686,5.969-5.969,5.969h-10.039 c-1.231,4.063-2.992,7.896-5.204,11.418l6.512,6.51c2.321,2.323,2.321,6.12,0,8.44l-8.818,8.819c-2.321,2.32-6.119,2.32-8.439,0 l-7.102-7.102c-3.657,1.96-7.601,3.456-11.753,4.406v9.199c0,3.282-2.685,5.968-5.968,5.968H53.629 c-3.283,0-5.969-2.686-5.969-5.968v-10.039c-4.063-1.232-7.896-2.993-11.417-5.205l-6.511,6.512c-2.323,2.321-6.12,2.321-8.441,0 l-8.818-8.818c-2.321-2.321-2.321-6.118,0-8.439l7.102-7.102c-1.96-3.657-3.456-7.6-4.405-11.751H5.968 C2.686,72.067,0,69.382,0,66.099V53.628c0-3.283,2.686-5.968,5.968-5.968h10.039c1.232-4.063,2.993-7.896,5.204-11.418l-6.511-6.51 c-2.321-2.322-2.321-6.12,0-8.44l8.819-8.819c2.321-2.321,6.118-2.321,8.439,0l7.101,7.101c3.658-1.96,7.601-3.456,11.753-4.406 V5.969C50.812,2.686,53.498,0,56.78,0h12.471c3.282,0,5.968,2.686,5.968,5.969v10.036c4.064,1.231,7.898,2.992,11.422,5.204 l6.507-6.509C95.471,12.379,99.268,12.379,101.589,14.7L101.589,14.7z M61.44,36.92c13.54,0,24.519,10.98,24.519,24.519 c0,13.538-10.979,24.519-24.519,24.519c-13.539,0-24.519-10.98-24.519-24.519C36.921,47.9,47.901,36.92,61.44,36.92L61.44,36.92z'
                      />
                    </g>
                  </svg>
                  <span className='some'>Settings</span>
                </a>
              </Link>
            </li>
          )}
          {/* {permissions.indexOf('view_users') !== -1 && (
            <li onClick={() => setcurrentTab(17)} className={currentTab == 17 ? 'active' : ''} id='nav-item-user'>
              <Link href='/users'>
                <a className='fill fs14 lh-50 display-b'>
                  <svg width='25' height='24' viewBox='0 0 20 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M9.5 11.5C12.5376 11.5 15 9.03757 15 6C15 2.96243 12.5376 0.5 9.5 0.5C6.46243 0.5 4 2.96243 4 6C4 9.03757 6.46243 11.5 9.5 11.5Z'
                      fill='#9BABC5'
                    />
                    <path
                      d='M19.0907 21.4988C18.7456 21.4988 18.4187 21.2901 18.2643 20.9485C16.7931 17.5801 13.5418 15.4072 10 15.4072C6.45816 15.4072 3.21602 17.5801 1.73571 20.9485C1.52683 21.4229 0.991017 21.6317 0.527853 21.4134C0.0737717 21.1952 -0.126024 20.6354 0.0828534 20.1515C1.85377 16.1093 5.74071 13.5 10 13.5C14.2502 13.5 18.1462 16.1093 19.9171 20.1515C20.126 20.6259 19.9262 21.1952 19.4721 21.4134C19.345 21.4704 19.2179 21.4988 19.0907 21.4988Z'
                      fill='#9BABC5'
                    />
                  </svg>{' '}
                  <span>User Management</span>
                </a>
              </Link>
            </li>
          )} */}
          {/* {
            <li
              onClick={() => setcurrentTab(29)}
              className={currentTab == 29 ? 'active' : ''}
              id='nav-item-schedulenotification'
            >
              <Link href='/schedule_notifications'>
                <a className='fill fs14 lh-50 display-b'>
                  <svg width='21' height='24' viewBox='0 0 21 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M18.4297 20.31H1.62974C1.01974 20.31 0.459739 19.97 0.179739 19.43C-0.100261 18.89 -0.0502608 18.23 0.309739 17.72C1.04974 16.67 1.47974 15.41 1.47974 14.27V9.55C1.47974 4.84 5.30974 1 10.0297 1C14.7497 1 18.5797 4.84 18.5797 9.55V14.27C18.5797 15.4 19.0097 16.66 19.7497 17.72C20.1097 18.22 20.1597 18.87 19.8797 19.42C19.5997 19.97 19.0397 20.31 18.4297 20.31ZM1.94974 18.87C1.93974 18.87 1.93974 18.87 1.94974 18.87C1.93974 18.87 1.93974 18.87 1.94974 18.87ZM2.30974 18.31H17.7497C16.9897 17.04 16.5797 15.63 16.5797 14.28V9.55C16.5797 5.94 13.6397 3 10.0297 3C6.41974 3 3.47974 5.94 3.47974 9.55V14.27C3.47974 15.63 3.06974 17.04 2.30974 18.31Z'
                      fill='#9BABC5'
                    ></path>
                    <path
                      d='M18.4297 20.31H1.62974C1.01974 20.31 0.459739 19.97 0.179739 19.43C-0.100261 18.89 -0.0502608 18.23 0.309739 17.72C1.04974 16.67 1.47974 15.41 1.47974 14.27V9.55C1.47974 4.84 5.30974 1 10.0297 1C14.7497 1 18.5797 4.84 18.5797 9.55V14.27C18.5797 15.4 19.0097 16.66 19.7497 17.72C20.1097 18.22 20.1597 18.87 19.8797 19.42C19.5997 19.97 19.0397 20.31 18.4297 20.31ZM1.94974 18.87C1.93974 18.87 1.93974 18.87 1.94974 18.87C1.93974 18.87 1.93974 18.87 1.94974 18.87ZM2.30974 18.31H17.7497C16.9897 17.04 16.5797 15.63 16.5797 14.28V9.55C16.5797 5.94 13.6397 3 10.0297 3C6.41974 3 3.47974 5.94 3.47974 9.55V14.27C3.47974 15.63 3.06974 17.04 2.30974 18.31Z'
                      fill='#9BABC5'
                    ></path>
                    <path
                      d='M10.0295 24C11.2595 24 12.2895 23.14 12.5395 22H7.51953C7.76953 23.14 8.79953 24 10.0295 24Z'
                      fill='#9BABC5'
                    ></path>
                    <path
                      d='M10.0295 24C11.2595 24 12.2895 23.14 12.5395 22H7.51953C7.76953 23.14 8.79953 24 10.0295 24Z'
                      fill='#9BABC5'
                    ></path>
                  </svg>
                  <span>Schedule Notifications</span>
                </a>
              </Link>
            </li>
          } */}

          {/* {permissions.indexOf('view_roles') !== -1 && (
            <li onClick={() => setcurrentTab(19)} className={currentTab == 19 ? 'active' : ''} id='nav-item-role'>
              <Link href='/roles'>
                <a className='fill fs14 lh-50 display-b'>
                  <svg version='1' width='25px' height='24px' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'>
                    <path
                      fill='#9BABC5'
                      d='M18.8,21.5c0.3-0.5,0.1-1.1-0.3-1.4L17,19.2V17c0-0.6-0.4-1-1-1s-1,0.4-1,1v2.2l-1.5,0.9c-0.5,0.3-0.6,0.9-0.3,1.4
    c0.3,0.5,0.9,0.6,1.4,0.3l1.4-0.9c0,0,0.1,0,0.1,0s0.1,0,0.1,0l1.4,0.9C17.6,22,17.8,22,18,22C18.3,22,18.7,21.8,18.8,21.5z'
                    />
                    <path
                      fill='#9BABC5'
                      d='M11,14l10,0c0.3,0,0.6-0.1,0.8-0.4c0.2-0.2,0.3-0.5,0.2-0.8c-0.3-1.5-1.4-2.7-2.9-3.1c-0.4-0.1-0.7-0.4-0.8-0.8
    C18.7,8.4,19,7.7,19,7V5c0-1.7-1.3-3-3-3s-3,1.3-3,3v2c0,0.7,0.3,1.4,0.7,1.9c-0.1,0.4-0.4,0.7-0.8,0.8c-1.5,0.4-2.6,1.6-2.8,3.1
    c-0.1,0.3,0,0.6,0.2,0.8C10.4,13.9,10.7,14,11,14z'
                    />
                    <path
                      fill='#9BABC5'
                      d='M27.1,25.7c-0.4-0.1-0.7-0.4-0.8-0.8c0.4-0.5,0.7-1.2,0.7-1.9v-2c0-1.7-1.3-3-3-3s-3,1.3-3,3v2c0,0.7,0.3,1.4,0.7,1.9
    c-0.1,0.4-0.4,0.7-0.8,0.8c-1.5,0.4-2.6,1.6-2.8,3.1c-0.1,0.3,0,0.6,0.2,0.8c0.2,0.2,0.5,0.4,0.8,0.4l10,0c0.3,0,0.6-0.1,0.8-0.4
    c0.2-0.2,0.3-0.5,0.2-0.8C29.7,27.3,28.5,26.1,27.1,25.7z'
                    />
                    <path
                      fill='#9BABC5'
                      d='M11.1,25.7c-0.4-0.1-0.7-0.4-0.8-0.8c0.4-0.5,0.7-1.2,0.7-1.9v-2c0-1.7-1.3-3-3-3s-3,1.3-3,3v2c0,0.7,0.3,1.4,0.7,1.9
    c-0.1,0.4-0.4,0.7-0.8,0.8c-1.5,0.4-2.6,1.6-2.8,3.1c-0.1,0.3,0,0.6,0.2,0.8C2.4,29.9,2.7,30,3,30l10,0c0.3,0,0.6-0.1,0.8-0.4
    c0.2-0.2,0.3-0.5,0.2-0.8C13.7,27.3,12.5,26.1,11.1,25.7z'
                    />
                  </svg>
                  <span>Roles</span>
                </a>
              </Link>
            </li>
          )} */}

          {/* {permissions.indexOf('view_address_annotation') !== -1 && (
            <li
              onClick={() => setcurrentTab(30)}
              className={currentTab === 30 ? 'active' : ''}
              id='nav-item-addressannotation'
            >
              <Link href='/address' as='/address'>
                <a className='fill fs14 lh-50 display-b'>
                  <svg version='1' width='25px' height='24px' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'>
                    <path
                      fill='#9BABC5'
                      d='M18.8,21.5c0.3-0.5,0.1-1.1-0.3-1.4L17,19.2V17c0-0.6-0.4-1-1-1s-1,0.4-1,1v2.2l-1.5,0.9c-0.5,0.3-0.6,0.9-0.3,1.4
    c0.3,0.5,0.9,0.6,1.4,0.3l1.4-0.9c0,0,0.1,0,0.1,0s0.1,0,0.1,0l1.4,0.9C17.6,22,17.8,22,18,22C18.3,22,18.7,21.8,18.8,21.5z'
                      className='path-to-fill'
                    />
                    <path
                      fill='#9BABC5'
                      d='M11,14l10,0c0.3,0,0.6-0.1,0.8-0.4c0.2-0.2,0.3-0.5,0.2-0.8c-0.3-1.5-1.4-2.7-2.9-3.1c-0.4-0.1-0.7-0.4-0.8-0.8
    C18.7,8.4,19,7.7,19,7V5c0-1.7-1.3-3-3-3s-3,1.3-3,3v2c0,0.7,0.3,1.4,0.7,1.9c-0.1,0.4-0.4,0.7-0.8,0.8c-1.5,0.4-2.6,1.6-2.8,3.1
    c-0.1,0.3,0,0.6,0.2,0.8C10.4,13.9,10.7,14,11,14z'
                      className='path-to-fill'
                    />
                    <path
                      fill='#9BABC5'
                      d='M27.1,25.7c-0.4-0.1-0.7-0.4-0.8-0.8c0.4-0.5,0.7-1.2,0.7-1.9v-2c0-1.7-1.3-3-3-3s-3,1.3-3,3v2c0,0.7,0.3,1.4,0.7,1.9
    c-0.1,0.4-0.4,0.7-0.8,0.8c-1.5,0.4-2.6,1.6-2.8,3.1c-0.1,0.3,0,0.6,0.2,0.8c0.2,0.2,0.5,0.4,0.8,0.4l10,0c0.3,0,0.6-0.1,0.8-0.4
    c0.2-0.2,0.3-0.5,0.2-0.8C29.7,27.3,28.5,26.1,27.1,25.7z'
                      className='path-to-fill'
                    />
                    <path
                      fill='#9BABC5'
                      d='M11.1,25.7c-0.4-0.1-0.7-0.4-0.8-0.8c0.4-0.5,0.7-1.2,0.7-1.9v-2c0-1.7-1.3-3-3-3s-3,1.3-3,3v2c0,0.7,0.3,1.4,0.7,1.9
    c-0.1,0.4-0.4,0.7-0.8,0.8c-1.5,0.4-2.6,1.6-2.8,3.1c-0.1,0.3,0,0.6,0.2,0.8C2.4,29.9,2.7,30,3,30l10,0c0.3,0,0.6-0.1,0.8-0.4
    c0.2-0.2,0.3-0.5,0.2-0.8C13.7,27.3,12.5,26.1,11.1,25.7z'
                      className='path-to-fill'
                    />
                  </svg>
                  <span>Address Annotation</span>
                </a>
              </Link>
            </li>
          )} */}

          {/* {permissions.indexOf('view_permissions') !== -1 && (
            <li onClick={() => setcurrentTab(21)} className={currentTab == 21 ? 'active' : ''} id='nav-item-permission'>
              <Link href='/permissions'>
                <a className='fill fs14 lh-50 display-b'>
                  <svg id='Layer_1' width='25px' height='24px' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128'>
                    <path
                      className='cls-1'
                      fill='#9BABC5'
                      d='M92.4285,92.70214a9.558,9.558,0,0,0-5.151-6.93676C78.32095,81.29915,58.66671,74.703,58.66671,74.703V68.21353l.54712-.4129a18.77694,18.77694,0,0,0,7.12945-11.93294l.11012-.69162h.53333a7.2534,7.2534,0,0,0,6.71314-4.51443,7.8988,7.8988,0,0,0,.98752-3.82622,7.26756,7.26756,0,0,0-.51614-2.69076,3.753,3.753,0,0,0-1.45547-2.33981l-1.81335-1.101.45075-1.96817c3.27573-14.2796-7.78668-27.14161-22.6409-27.496-.36127-.00688-.71912-.01029-1.07354-.00344-.35442-.00685-.71225-.00344-1.07354.00344C31.711,11.594,20.6486,24.456,23.9243,38.73564l.45075,1.96817-1.81332,1.101a3.753,3.753,0,0,0-1.4555,2.33981,7.26754,7.26754,0,0,0-.51611,2.69076,7.89848,7.89848,0,0,0,.98752,3.82622,7.25339,7.25339,0,0,0,6.71311,4.51443h.53333l.11012.69162a18.77694,18.77694,0,0,0,7.12945,11.93294l.54712.4129V74.703S16.95657,81.29915,8,85.76538a9.55783,9.55783,0,0,0-5.151,6.93676c-1.53464,8.95659-1.80645,24.06542-1.80645,24.06542H94.235S93.96311,101.65873,92.4285,92.70214Z'
                    />
                    <path
                      className='cls-2'
                      fill='#9BABC5'
                      d='M121.37018,34.15191V27.59562a16.35974,16.35974,0,1,0-32.71949,0v6.57a6.06113,6.06113,0,0,0-5.58722,6.03394V61.1398A6.079,6.079,0,0,0,89.11805,67.16H120.9097a6.05661,6.05661,0,0,0,6.04774-6.0477V40.179A6.05471,6.05471,0,0,0,121.37018,34.15191ZM107.80409,51.05109l-.39861.31615v5.38109a2.25825,2.25825,0,0,1-1.16831,2.09607,2.545,2.545,0,0,1-2.48092-.055,2.40684,2.40684,0,0,1-1.14768-2.048V51.381l-.12374-.1031-.25428-.20616A4.28921,4.28921,0,0,1,101.021,45.89a4.36726,4.36726,0,0,1,4.79008-2.52908h.00688a4.44018,4.44018,0,0,1,3.608,4.26777A4.21607,4.21607,0,0,1,107.80409,51.05109Zm7.61458-16.89919H94.59533V27.59562a10.41167,10.41167,0,1,1,20.82334,0Z'
                    />
                  </svg>
                  <span>Permissions</span>
                </a>
              </Link>
            </li>
          )} */}
          {/* {permissions.includes('onboarding') && (
            <li onClick={() => setcurrentTab(25)} className={currentTab === 25 ? 'active' : ''}>
              <Link href='/merchant-onboarding'>
                <a className='fill fs14 lh-50 display-b'>
                  <svg
                    version='1.1'
                    id='Layer_1'
                    width='25px'
                    height='24px'
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 122.88 115.48'
                  >
                    <path
                      className='st0'
                      fill='#9BABC5'
                      d='M39.54,70.85l8.78,25.83l4.42-15.33l-2.17-2.37c-0.98-1.42-1.19-2.67-0.65-3.74c1.17-2.32,3.6-1.89,5.87-1.89 c2.38,0,5.31-0.45,6.05,2.52c0.25,0.99-0.06,2.04-0.76,3.11l-2.17,2.37l4.42,15.33l7.95-25.83c1.71,1.53,4.4,2.7,7.52,3.68 c0.47-0.56,0.97-1.11,1.49-1.63c4.51-4.51,10.75-7.31,17.64-7.31c6.89,0,13.12,2.79,17.64,7.31c4.51,4.51,7.31,10.75,7.31,17.64 s-2.79,13.12-7.31,17.64c-4.51,4.51-10.75,7.31-17.64,7.31c-5.22,0-10.07-1.61-14.08-4.35H6.07c-3.81-0.29-5.75-2.26-6.07-5.67 c0.97-6.57,1.24-15.16,5.24-20.45c1.45-1.92,3.26-3.34,5.26-4.45C16.82,77.04,33.8,76.01,39.54,70.85L39.54,70.85z M85.11,92.67 l4.54-4.76l6.55,6.3l10.2-13.59l5.07,4.09c-2.39,2.96-10.91,14.65-12.77,16.17c-1.53,1.25-3.73,1.25-5.15-0.12L85.11,92.67 L85.11,92.67z M112.95,75.52c-3.84-3.84-9.15-6.22-15.02-6.22c-5.87,0-11.18,2.38-15.02,6.22c-3.84,3.84-6.22,9.15-6.22,15.02 c0,5.87,2.38,11.18,6.22,15.02c3.84,3.84,9.15,6.22,15.02,6.22c5.87,0,11.18-2.38,15.02-6.22c3.84-3.84,6.22-9.15,6.22-15.02 C119.18,84.67,116.8,79.36,112.95,75.52L112.95,75.52z M35.32,33.91c0.68,0.19,1.38,0.21,2.11,0.06l-1.25-9.91 c0.64-2.45,1.62-4.36,2.92-5.76c1.36-1.46,3.06-2.37,5.09-2.76c2.69-0.19,3.5,1.77,6.19,3.49c8.18,5.23,15.1,6.99,25.21,7.12 l-1.25,6.32c-0.17,0.26-0.26,0.58-0.23,0.91c0,0.05,0.01,0.11,0.02,0.16l-0.18,0.9c0.28,0.02,0.55,0.03,0.82,0.02 c0.25,0.15,0.55,0.23,0.87,0.2c1.76-0.16,2.83,0,3.12,0.59c0.4,0.8,0.06,2.43-1.09,5.05l-5.53,9.11c-2.06,3.39-4.14,6.78-6.79,9.25 c-2.54,2.38-5.67,3.96-9.94,3.95c-3.95-0.01-6.93-1.53-9.4-3.78c-2.56-2.34-4.63-5.53-6.59-8.66l-4.91-7.81l0,0l-0.02-0.03 c-1.51-2.25-2.29-4.19-2.33-5.68c-0.01-0.5,0.06-0.94,0.23-1.3c0.15-0.32,0.38-0.59,0.7-0.81C33.62,34.19,34.36,33.98,35.32,33.91 L35.32,33.91L35.32,33.91z M78.98,32.1l0.31-12.72c-0.37-5.17-2.08-9.08-4.81-12.03c-6.69-7.24-19.19-9.1-28.62-5.69 c-1.59,0.57-3.09,1.3-4.46,2.17c-3.89,2.48-7.04,6.09-8.29,10.57c-0.3,1.06-0.5,2.12-0.61,3.18c-0.2,4.46-0.09,9.78,0.23,14.01 c-0.44,0.17-0.84,0.37-1.2,0.61c-0.76,0.51-1.33,1.18-1.7,1.97c-0.35,0.76-0.51,1.62-0.48,2.57c0.06,2.01,0.99,4.47,2.79,7.15 l4.91,7.8c2.07,3.28,4.24,6.64,7.08,9.24c2.94,2.69,6.53,4.51,11.3,4.53c5.11,0.01,8.84-1.88,11.87-4.71 c2.92-2.74,5.12-6.3,7.27-9.85l5.59-9.21c0.03-0.05,0.06-0.11,0.08-0.16l0,0c1.53-3.47,1.86-5.89,1.06-7.49 C80.84,33.05,80.06,32.43,78.98,32.1L78.98,32.1L78.98,32.1z'
                    />
                  </svg>
                  <span>Onboarding</span>
                </a>
              </Link>
            </li>
          )} */}
          {/* {permissions.indexOf('historical_data') != -1 && (
            <li
              onClick={() => setcurrentTab(23)}
              className={currentTab == 23 ? 'active' : ''}
              id='nav-item-historicaldata'
            >
              <Link href='/historical-data'>
                <a className='fill fs14 lh-50 display-b'>
                  <svg width='20' height='22' viewBox='0 0 23 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M1 1L6.24128 5.12571L11.4942 1L16.7471 5.12571L22 1V21.6514C22 23.5029 20.4776 25 18.5949 25H4.40509C2.52241 25 1 23.5029 1 21.6514V1Z'
                      stroke='#9BABC5'
                      strokeWidth='2'
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                    <path
                      d='M6.8457 18.4971H16.1429'
                      stroke='#9BABC5'
                      strokeWidth='2'
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                    <path
                      d='M6.8457 11.6401H16.1429'
                      stroke='#9BABC5'
                      strokeWidth='2'
                      strokeMiterlimit='10'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                  <span className='some'>Historical Data</span>
                </a>
              </Link>
            </li>
          )} */}
        </ul>
      </div>
    )
  );
};

export default nav;
